<!--
  - Copyright (c) 2023.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            v-if="!show"
            title="下载"
            left-arrow
            @click-left="$router.go(-1)"
        >
        </van-nav-bar>
        <div class="content">
            <van-icon name="records" size="80" color="var(--color)"/>
            <div v-html="title" style="margin-top: 10px;color: var(--color);font-size: 18px;font-weight: 600;"></div>
            <div style="margin-top: 80px;">
                <van-button v-for="(url,index) in urls" :url="url" icon="down" color="var(--color)" type="info" block
                            style="margin-bottom: 10px;">{{ urls.length===1?'下载':('下载第'+(index+1)+'项') }}
                </van-button>

                <van-button type="danger" @click="$router.go(-1)" block style="">返回
                </van-button>
            </div>
        </div>

        <van-overlay :show="show" >
            <div style="text-align: right;padding: 10px;">
                <img src="../assets/open_with_browser.png" style="max-width: 300px;height: auto;" />
            </div>
        </van-overlay>

    </div>
</template>

<script>
export default {
    name: "Downloads",
    data() {
        return {
            title: '',
            urls: [],

            show: false,

        }
    },
    created() {
        this.urls = this.$route.query.urls?this.$route.query.urls.split(','):[];
        if (this.urls.length === 0) {
            this.$router.go(-1);
            return;
        }
        this.title = this.$route.query.title;

        var ua = navigator.userAgent;
        var isWeixin = !!/MicroMessenger/i.test(ua);
        if(isWeixin) {
            this.show = true;
        }
    }
}
</script>

<style lang="less" scoped>
    .content {
        text-align: center;
        margin: 0 auto;
        height: auto;
        padding: 80px 10px 10px 10px;

    img {
        width: 100%;
    }

    p {
        margin: 15px 15px 30px;
        color: #888;
    }

}

</style>